import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1d4bbba8 = () => interopDefault(import('../pages/403/index.vue' /* webpackChunkName: "pages/403/index" */))
const _9b9f232e = () => interopDefault(import('../pages/404/index.vue' /* webpackChunkName: "pages/404/index" */))
const _038161a7 = () => interopDefault(import('../pages/article/index.vue' /* webpackChunkName: "pages/article/index" */))
const _91c94102 = () => interopDefault(import('../pages/articles.vue' /* webpackChunkName: "pages/articles" */))
const _7aeeade6 = () => interopDefault(import('../pages/articles/_section.vue' /* webpackChunkName: "pages/articles/_section" */))
const _30c598e5 = () => interopDefault(import('../pages/cart/index.vue' /* webpackChunkName: "pages/cart/index" */))
const _35e34fc7 = () => interopDefault(import('../pages/catalog.vue' /* webpackChunkName: "pages/catalog" */))
const _12175d15 = () => interopDefault(import('../pages/catalog/_category.vue' /* webpackChunkName: "pages/catalog/_category" */))
const _73230e8b = () => interopDefault(import('../pages/checkout/index.vue' /* webpackChunkName: "pages/checkout/index" */))
const _bbf61820 = () => interopDefault(import('../pages/contact-us/index.vue' /* webpackChunkName: "pages/contact-us/index" */))
const _3b46f2c7 = () => interopDefault(import('../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _329d4d3e = () => interopDefault(import('../pages/holiday-sale/index.vue' /* webpackChunkName: "pages/holiday-sale/index" */))
const _3ea1cc84 = () => interopDefault(import('../pages/maintenance/index.vue' /* webpackChunkName: "pages/maintenance/index" */))
const _24eda4e6 = () => interopDefault(import('../pages/more-than-words/index.vue' /* webpackChunkName: "pages/more-than-words/index" */))
const _2fc784e5 = () => interopDefault(import('../pages/our-story/index.vue' /* webpackChunkName: "pages/our-story/index" */))
const _24b5cacc = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _cfead41c = () => interopDefault(import('../pages/returns-exchange/index.vue' /* webpackChunkName: "pages/returns-exchange/index" */))
const _a139bce0 = () => interopDefault(import('../pages/profile/orders/index.vue' /* webpackChunkName: "pages/profile/orders/index" */))
const _59af76d6 = () => interopDefault(import('../pages/profile/production-tracking/index.vue' /* webpackChunkName: "pages/profile/production-tracking/index" */))
const _b3343924 = () => interopDefault(import('../pages/profile/shipping-addresses/index.vue' /* webpackChunkName: "pages/profile/shipping-addresses/index" */))
const _28b5927e = () => interopDefault(import('../pages/profile/production-tracking/_id/index.vue' /* webpackChunkName: "pages/profile/production-tracking/_id/index" */))
const _8ab30aca = () => interopDefault(import('../pages/pages-preview/_id/index.vue' /* webpackChunkName: "pages/pages-preview/_id/index" */))
const _6b0245d0 = () => interopDefault(import('../pages/product/_slug.vue' /* webpackChunkName: "pages/product/_slug" */))
const _096dd676 = () => interopDefault(import('../pages/recover-password/_token/index.vue' /* webpackChunkName: "pages/recover-password/_token/index" */))
const _3ae367dd = () => interopDefault(import('../pages/returns-exchange/_id/index.vue' /* webpackChunkName: "pages/returns-exchange/_id/index" */))
const _dbd2e7d6 = () => interopDefault(import('../pages/thank-you/_id.vue' /* webpackChunkName: "pages/thank-you/_id" */))
const _8fb621fe = () => interopDefault(import('../pages/verify/_token/index.vue' /* webpackChunkName: "pages/verify/_token/index" */))
const _f334fd00 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _379f468a = () => interopDefault(import('../pages/_slug/index.vue' /* webpackChunkName: "pages/_slug/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/403",
    component: _1d4bbba8,
    name: "403___en"
  }, {
    path: "/404",
    component: _9b9f232e,
    name: "404___en"
  }, {
    path: "/article",
    component: _038161a7,
    name: "article___en"
  }, {
    path: "/articles",
    component: _91c94102,
    name: "articles___en",
    children: [{
      path: ":section?",
      component: _7aeeade6,
      name: "articles/section___en"
    }]
  }, {
    path: "/cart",
    component: _30c598e5,
    name: "cart___en"
  }, {
    path: "/catalog",
    component: _35e34fc7,
    name: "catalog___en",
    children: [{
      path: ":category?",
      component: _12175d15,
      name: "catalog/category___en"
    }]
  }, {
    path: "/checkout",
    component: _73230e8b,
    name: "checkout___en"
  }, {
    path: "/contact-us",
    component: _bbf61820,
    name: "contact-us___en"
  }, {
    path: "/faq",
    component: _3b46f2c7,
    name: "faq___en"
  }, {
    path: "/holiday-sale",
    component: _329d4d3e,
    name: "holiday-sale___en"
  }, {
    path: "/maintenance",
    component: _3ea1cc84,
    name: "maintenance___en"
  }, {
    path: "/more-than-words",
    component: _24eda4e6,
    name: "more-than-words___en"
  }, {
    path: "/our-story",
    component: _2fc784e5,
    name: "our-story___en"
  }, {
    path: "/profile",
    component: _24b5cacc,
    name: "profile___en"
  }, {
    path: "/returns-exchange",
    component: _cfead41c,
    name: "returns-exchange___en"
  }, {
    path: "/profile/orders",
    component: _a139bce0,
    name: "profile/orders___en"
  }, {
    path: "/profile/production-tracking",
    component: _59af76d6,
    name: "profile/production-tracking___en"
  }, {
    path: "/profile/shipping-addresses",
    component: _b3343924,
    name: "profile/shipping-addresses___en"
  }, {
    path: "/profile/production-tracking/:id",
    component: _28b5927e,
    name: "profile/production-tracking/id___en"
  }, {
    path: "/pages-preview/:id",
    component: _8ab30aca,
    name: "pages-preview/id___en"
  }, {
    path: "/product/:slug?",
    component: _6b0245d0,
    name: "product/slug___en"
  }, {
    path: "/recover-password/:token",
    component: _096dd676,
    name: "recover-password/token___en"
  }, {
    path: "/returns-exchange/:id",
    component: _3ae367dd,
    name: "returns-exchange/id___en"
  }, {
    path: "/thank-you/:id?",
    component: _dbd2e7d6,
    name: "thank-you/id___en"
  }, {
    path: "/verify/:token",
    component: _8fb621fe,
    name: "verify/token___en"
  }, {
    path: "/articles/:section/:slug",
    component: _038161a7
  }, {
    path: "/",
    component: _f334fd00,
    name: "index___en"
  }, {
    path: "/:slug",
    component: _379f468a,
    name: "slug___en"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
